const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3002/api';
const PROJECT = 'ekg';

const getToken = () => localStorage.getItem('token');

async function request(endpoint, options = {}) {
  const token = getToken();

  const config = {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    },
  };

  const response = await fetch(`${API_BASE}${endpoint}`, config);
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Request failed');
  }

  return data;
}

export const authAPI = {
  register: (email, password, name) =>
    request('/auth/register', {
      method: 'POST',
      body: JSON.stringify({ email, password, name }),
    }),

  login: (email, password) =>
    request('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    }),

  me: () => request('/auth/me'),
};

export const progressAPI = {
  getAll: () => request(`/progress?project=${PROJECT}`),

  getPart: (partNumber) => request(`/progress/part/${partNumber}?project=${PROJECT}`),

  saveAnswer: (partNumber, questionId, selectedAnswer, isCorrect) =>
    request('/progress/answer', {
      method: 'POST',
      body: JSON.stringify({ partNumber, questionId, selectedAnswer, isCorrect, project: PROJECT }),
    }),

  completePart: (partNumber, score, totalQuestions) =>
    request('/progress/complete', {
      method: 'POST',
      body: JSON.stringify({ partNumber, score, totalQuestions, project: PROJECT }),
    }),
};

export const reportsAPI = {
  getAll: () => request(`/reports?project=${PROJECT}`),

  submit: (questionId, partNumber, questionStem, comment) =>
    request('/reports', {
      method: 'POST',
      body: JSON.stringify({ questionId, partNumber, questionStem, comment, project: PROJECT }),
    }),

  resolve: (id) =>
    request(`/reports/${id}/resolve`, { method: 'PATCH' }),

  delete: (id) =>
    request(`/reports/${id}`, { method: 'DELETE' }),

  deleteAll: () =>
    request(`/reports?project=${PROJECT}`, { method: 'DELETE' }),
};

export const analyticsAPI = {
  getStats: () => request(`/analytics?project=${PROJECT}`),
};

export const bookmarksAPI = {
  getAll: () => request(`/bookmarks?project=${PROJECT}`),

  add: (questionId, partNumber) =>
    request('/bookmarks', {
      method: 'POST',
      body: JSON.stringify({ questionId, partNumber, project: PROJECT }),
    }),

  remove: (questionId) =>
    request(`/bookmarks/${questionId}?project=${PROJECT}`, { method: 'DELETE' }),
};

export const notesAPI = {
  getAll: () => request(`/notes?project=${PROJECT}`),

  get: (questionId) => request(`/notes/${questionId}?project=${PROJECT}`),

  save: (questionId, content) =>
    request(`/notes/${questionId}`, {
      method: 'PUT',
      body: JSON.stringify({ content, project: PROJECT }),
    }),

  delete: (questionId) =>
    request(`/notes/${questionId}?project=${PROJECT}`, { method: 'DELETE' }),
};

export const strikethroughsAPI = {
  getAll: () => request(`/strikethroughs?project=${PROJECT}`),

  add: (questionId, optionIndex) =>
    request('/strikethroughs', {
      method: 'POST',
      body: JSON.stringify({ questionId, optionIndex, project: PROJECT }),
    }),

  remove: (questionId, optionIndex) =>
    request(`/strikethroughs/${questionId}/${optionIndex}?project=${PROJECT}`, {
      method: 'DELETE',
    }),

  clearQuestion: (questionId) =>
    request(`/strikethroughs/${questionId}?project=${PROJECT}`, { method: 'DELETE' }),
};

export const sessionsAPI = {
  create: (mode, questionIds, timeLimit = null) =>
    request('/sessions', {
      method: 'POST',
      body: JSON.stringify({ mode, questionIds, timeLimit, project: PROJECT }),
    }),

  get: (sessionId) => request(`/sessions/${sessionId}?project=${PROJECT}`),

  getAll: () => request(`/sessions?project=${PROJECT}`),

  updateProgress: (sessionId, currentIndex) =>
    request(`/sessions/${sessionId}`, {
      method: 'PATCH',
      body: JSON.stringify({ currentIndex }),
    }),

  complete: (sessionId) =>
    request(`/sessions/${sessionId}/complete`, { method: 'POST' }),
};

export const timesAPI = {
  save: (questionId, timeSeconds) =>
    request('/times', {
      method: 'POST',
      body: JSON.stringify({ questionId, timeSeconds, project: PROJECT }),
    }),

  getAll: () => request(`/times?project=${PROJECT}`),
};
